/**
 * Console utility for environment-aware logging
 * 
 * In production, all console methods are disabled to prevent
 * leaking debug information to users
 */

const isDev = process.env.NODE_ENV === 'development';

/**
 * Initialize console overrides for production
 * Call this once at app initialization (client-side)
 */
export const initializeConsole = (): void => {
  if (typeof window === 'undefined') return;
  
  if (!isDev) {
    // Store original methods in case we need them
    const originalConsole = {
      log: console.log,
      warn: console.warn,
      info: console.info,
      debug: console.debug,
      error: console.error, // Keep errors for critical issues
    };

    // Override console methods in production
    console.log = () => {};
    console.warn = () => {};
    console.info = () => {};
    console.debug = () => {};
    
    // Keep console.error for critical production issues
    // but you can also disable it if needed:
    // console.error = () => {};

    // Expose a way to use original console if absolutely needed
    (window as any).__originalConsole = originalConsole;
  }
};

/**
 * Development-only logger that won't log in production
 * Use this for debug logging that should never appear in production
 */
export const devLog = (...args: any[]): void => {
  if (isDev) {
    console.log(...args);
  }
};

export const devWarn = (...args: any[]): void => {
  if (isDev) {
    console.warn(...args);
  }
};

export const devInfo = (...args: any[]): void => {
  if (isDev) {
    console.info(...args);
  }
};

export const devError = (...args: any[]): void => {
  if (isDev) {
    console.error(...args);
  }
};

export default {
  initializeConsole,
  devLog,
  devWarn,
  devInfo,
  devError,
};

